import * as React from 'react';

export const Radio: React.FC<{ has?: 'error' | 'success' | 'warning' }> = ({ children, has }) => (
  <div className={has ? `has-${has}` : undefined}>
    <div className="radio">
      <label>{children}</label>
    </div>
  </div>
);
